import React, { useEffect, useState } from "react";
import CardEmpty from "Utils/Cards/CardEmpty";
import { NotificationManager } from "react-notifications";
import { ListadoTrasladosApi } from "../../api/ListadoTrasladosApi";
import Paginacion from "../../../../../../Utils/Components/Paginacion/Paginacion";
import LoadMask from "../../../../../../Utils/LoadMask/LoadMask";
import { useForm } from "react-hook-form";
import moment from "moment";
import { FiltrosTabs } from "../../../../components/FiltosTabs";
import { FinalizadosTable } from "./FinalizadosTable";
import { ModalIngresos } from "../../../../components/ModalIngresos";
import { useDebounce } from "../../../../../../Utils/Hooks/useDebounce";
import {
    dateToDayEnd,
    dateToDayStart,
    getErrorFromResponse,
} from "../../../../../../../../utility/utils";
import { TrasladosApi } from "../../../../api/TrasladosApi";

export const FinalizadosTab = ({ estado, storageKey, modo }) => {
    const STORAGE_KEY = storageKey;
    const savedState = JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {};
    const filtros = savedState && savedState.filtros ? savedState.filtros : {};

    const searchDefault = filtros.search || "";
    const fechaInicialDefault = filtros.fecha_inicial
        ? moment(filtros.fecha_inicial)
        : null;

    const fechaFinalDefault = filtros.fecha_final
        ? moment(filtros.fecha_final)
        : null;

    const { control, watch } = useForm({
        defaultValues: {
            search: searchDefault,
            fecha_inicial: fechaInicialDefault,
            fecha_final: fechaFinalDefault,
        },
    });

    const [traslados, setTraslados] = useState([]);
    const [paginaSeleccionada, setPaginaSeleccionada] = useState(
        savedState.pagina || 1,
    );
    const [cantidadResultados, setCantidadResultados] = useState(0);

    const [trasladoSeleccionado, setTrasladoSeleccionado] = useState(null);

    const search = watch("search");
    const debouncedSearch = useDebounce(search, 500);
    const fecha_inicial = watch("fecha_inicial");
    const fecha_final = watch("fecha_final");

    const { getTrasladosFinalizados, cargando } = ListadoTrasladosApi();

    const { getTrasladoDetalle, cargando: cargandoDetalle } = TrasladosApi();

    const VerDetalleTraslado = async (trasladoId) => {
        try {
            const traslado = await getTrasladoDetalle(trasladoId);
            setTrasladoSeleccionado(traslado);
        } catch (error) {
            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener el detalle del traslado",
            );
            NotificationManager.error(errorMsg, "Error", 3000);
        }
    };

    const GetTraslados = async () => {
        try {
            const params = {
                page: paginaSeleccionada,
                estado: estado,
                modo: modo,
            };

            if (debouncedSearch) params.search = debouncedSearch;

            if (fecha_inicial) {
                params.fecha_inicial = dateToDayStart(fecha_inicial);
            }

            if (fecha_final) {
                params.fecha_final = dateToDayEnd(fecha_final);
            }

            const response = await getTrasladosFinalizados(params);
            setTraslados(response.results);
            setCantidadResultados(response.count);
        } catch (error) {
            // Si el error es por una página inválida, volvemos a la página anterior
            if (
                error &&
                error.detail === "Invalid page." &&
                paginaSeleccionada > 1
            ) {
                setPaginaSeleccionada((prev) => prev - 1);
                return;
            }

            const errorMsg = getErrorFromResponse(
                error,
                "Error al obtener traslados finalizados",
            );
            NotificationManager.error(errorMsg, "Error", 3000);

            setTraslados([]);
            setCantidadResultados(0);
        }
    };

    useEffect(() => {
        GetTraslados();
    }, [paginaSeleccionada, debouncedSearch, fecha_inicial, fecha_final]);

    useEffect(() => {
        const stateToSave = {
            filtros: {
                search: debouncedSearch,
                fecha_inicial,
                fecha_final,
            },
            pagina: paginaSeleccionada,
        };

        sessionStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    }, [debouncedSearch, fecha_inicial, fecha_final, paginaSeleccionada]);

    return (
        <div className="listado-traslados__tab-wrapper">
            <LoadMask loading={cargando || cargandoDetalle} blur>
                <CardEmpty noShadow>
                    <div className="listado-traslados__table-header">
                        <FiltrosTabs
                            control={control}
                            onRefresh={GetTraslados}
                            resetPage={() => setPaginaSeleccionada(1)}
                            searchPlaceholder={"Número, recepción, finca"}
                        />
                    </div>

                    <FinalizadosTable
                        traslados={traslados}
                        verDetalleTraslado={VerDetalleTraslado}
                        modo={modo}
                    />
                    <Paginacion
                        cantidadResultados={cantidadResultados}
                        paginaSeleccionada={paginaSeleccionada}
                        setPaginaSeleccionada={setPaginaSeleccionada}
                    />
                </CardEmpty>
            </LoadMask>
            {trasladoSeleccionado && (
                <ModalIngresos
                    opened={!!trasladoSeleccionado}
                    onClose={() => setTrasladoSeleccionado(null)}
                    trasladoSeleccionado={trasladoSeleccionado}
                />
            )}
        </div>
    );
};
